import React from 'react';
const { Icon, Card, Button } = window;
/* ============================================================
   BOOKER — Tela: Aditivos (entidade própria, vínculo ao contrato-base)
   ============================================================ */
var { useState, useEffect, useMemo } = React;

function Aditivos({ onNavigate }) {
  const DB = window.DB;
  const [lista, setLista] = useState(null);
  const [erro, setErro] = useState('');
  const [busca, setBusca] = useState('');
  const [fStatus, setFStatus] = useState('all');
  const [sel, setSel] = useState({});
  const [busy, setBusy] = useState('');
  const [pend, setPend] = useState([]); // arquivos no SharePoint ainda não importados
  const [pastaUrl, setPastaUrl] = useState('');
  const [sincronizando, setSincronizando] = useState(false);
  const bases = useMemo(() => DB.contratosComCliente().filter(c => c.dbId), []);
  const podeEditar = window.podeEditar ? window.podeEditar() : true;

  async function carregar() {
    try { setLista(await window.Api.apiAditivos()); setErro(''); }
    catch (e) { setErro(e.message); setLista([]); }
    window.Api.apiSharepointPendentes('aditivos').then(d => { setPend((d && d.pendentes) || []); setPastaUrl((d && d.pastaUrl) || ''); }).catch(() => setPend([]));
  }
  useEffect(() => { carregar(); }, []);

  async function sincronizar() {
    setSincronizando(true);
    try {
      const r = await window.Api.apiSharepointSincronizar('aditivos');
      if (r && r.ok) window.avisar(`Sincronizado! ${r.ligados} ligado(s), ${r.religados} religado(s)` + (r.novos ? `, ${r.novos} novo(s) a revisar` : '') + '.');
      else window.avisar((r && r.erro) || 'Falha ao sincronizar.');
      carregar();
    } catch (e) { window.avisar(e.message); }
    finally { setSincronizando(false); }
  }
  async function importarPend(p) {
    try {
      const r = await window.Api.apiSharepointImportar(p.id);
      window.avisar(r.tipoDoc === 'aditivo' ? 'Aditivo importado! ✅' : 'Importado como contrato (não era aditivo).');
      carregar(); if (window.recarregarContratos) window.recarregarContratos();
    } catch (e) { window.avisar(e.message); }
  }
  async function dispensarPend(p) {
    if (!await window.confirmar(`Dispensar "${p.nome}" da lista? (não apaga do SharePoint — só some daqui)`)) return;
    try { await window.Api.apiSharepointIgnorar(p.id); carregar(); }
    catch (e) { window.avisar(e.message); }
  }

  async function vincular(a) {
    const sug = baseSugerida(a);
    const baseId = sel[a.id] || (sug ? sug.dbId : '') || a.contratoBaseId;
    if (!baseId) { window.avisar('Escolha o contrato-base.'); return; }
    setBusy(a.id);
    try { await window.Api.apiAditivoVincular(a.id, Number(baseId)); await carregar(); if (window.recarregarContratos) window.recarregarContratos(); }
    catch (e) { window.avisar(e.message); } finally { setBusy(''); }
  }
  async function desvincular(a) {
    setBusy(a.id);
    try { await window.Api.apiAditivoVincular(a.id, null); await carregar(); }
    catch (e) { window.avisar(e.message); } finally { setBusy(''); }
  }
  async function excluir(a) {
    if (busy === a.id) return;
    if (!await window.confirmar(`Excluir o aditivo ${a.codigo}?\n\nRemove o documento e o PDF — não tem como desfazer.`)) return;
    setBusy(a.id);
    try { await window.Api.apiAditivoExcluir(a.id); await carregar(); if (window.recarregarContratos) window.recarregarContratos(); }
    catch (e) { window.avisar(e.message); } finally { setBusy(''); }
  }
  async function aplicar(a) {
    if (!await window.confirmar('Aplicar o rateio deste aditivo ao contrato-base? Cria uma nova vigência e preserva o histórico.')) return;
    setBusy(a.id);
    try { const r = await window.Api.apiAditivoAplicar(a.id); window.avisar(`Aplicado: novo total R$ ${r.total} desde ${r.vigencia} (${r.empresas} empresa(s)).`); await carregar(); if (window.recarregarContratos) window.recarregarContratos(); }
    catch (e) { window.avisar(e.message); } finally { setBusy(''); }
  }

  const baseSugerida = (a) => {
    const dig = (a.cnpj || '').replace(/\D/g, '');
    if (!dig || dig === '—') return null;
    return bases.find(b => (b.cliente.cnpj || '').replace(/\D/g, '') === dig) || null;
  };

  const aditivos = lista || [];
  const kpis = useMemo(() => ({
    total: aditivos.length,
    vinculados: aditivos.filter(a => a.contratoBaseId).length,
    naoVinc: aditivos.filter(a => !a.contratoBaseId).length,
  }), [aditivos]);

  const filtrada = useMemo(() => {
    const q = busca.trim().toLowerCase();
    return aditivos.filter(a => {
      if (fStatus === 'vinculado' && !a.contratoBaseId) return false;
      if (fStatus === 'naovinculado' && a.contratoBaseId) return false;
      if (q && !((a.arquivo || '').toLowerCase().includes(q) || (a.codigo || '').toLowerCase().includes(q) ||
        (a.razao || '').toLowerCase().includes(q) || (a.base && (a.base.codigo || '').toLowerCase().includes(q)))) return false;
      return true;
    });
  }, [aditivos, busca, fStatus]);

  const campoSel = { padding: '7px 9px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border-strong)', background: 'var(--surface-2)', color: 'var(--text-strong)', fontSize: 12.5, outline: 'none', maxWidth: 240 };

  return (
    <div style={{ animation: 'fadeUp .4s ease both' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 16, marginBottom: 22 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: 'var(--text-strong)', letterSpacing: '-.02em' }}>Aditivos</h1>
          <p style={{ margin: '5px 0 0', color: 'var(--text-muted)', fontSize: 14 }}>Vínculo dos aditivos aos contratos-base · {aditivos.length}</p>
          {pastaUrl && (
            <a href={pastaUrl} target="_blank" rel="noopener noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 7, fontSize: 12.5, fontWeight: 700, color: 'var(--booker-orange)', textDecoration: 'none' }}>
              <Icon name="external" size={14} /> Abrir a pasta de aditivos no SharePoint
            </a>
          )}
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {podeEditar
            ? <Button variant="accent" size="md" icon="refresh" onClick={sincronizar}>{sincronizando ? 'Sincronizando…' : 'Sincronizar SharePoint'}</Button>
            : <Button variant="default" size="md" icon="refresh" onClick={carregar}>Atualizar</Button>}
        </div>
      </div>

      {erro && <Card pad={20} style={{ marginBottom: 16, color: 'var(--danger)' }}>{erro}</Card>}

      {pend.length > 0 && (
        <Card pad={0} style={{ marginBottom: 16, border: '1px solid var(--booker-orange)' }}>
          <div style={{ padding: '14px 18px 10px', display: 'flex', alignItems: 'center', gap: 10 }}>
            <Icon name="link" size={17} style={{ color: 'var(--booker-orange)' }} />
            <h3 style={{ margin: 0, fontSize: 14.5, fontWeight: 800, color: 'var(--text-strong)' }}>No SharePoint, ainda não importados</h3>
            <span style={{ background: 'var(--warn-bg)', color: 'var(--booker-orange)', fontWeight: 800, fontSize: 12, padding: '2px 8px', borderRadius: 99 }}>{pend.length}</span>
          </div>
          {pend.map(p => (
            <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '11px 18px', borderTop: '1px solid var(--border)' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-strong)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.nome}</div>
                <div style={{ fontSize: 11, color: 'var(--booker-orange)', fontWeight: 700 }}>Arquivo novo na pasta de aditivos</div>
              </div>
              <Button size="sm" variant="ghost" icon="external" onClick={() => window.Api.abrirSharepoint(p.id).catch(e => window.avisar(e.message))}>Abrir</Button>
              {podeEditar && <Button size="sm" variant="accent" icon="download" onClick={() => importarPend(p)}>Importar</Button>}
              {podeEditar && <Button size="sm" variant="ghost" icon="x" onClick={() => dispensarPend(p)}>Dispensar</Button>}
            </div>
          ))}
        </Card>
      )}

      {aditivos.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14, marginBottom: 18 }}>
          <Kpi label="Total de aditivos" value={kpis.total} tone="var(--text-strong)" />
          <Kpi label="Vinculados" value={kpis.vinculados} tone="var(--ok)" />
          <Kpi label="Não vinculados" value={kpis.naoVinc} tone="var(--booker-orange)" />
        </div>
      )}

      {aditivos.length > 0 && (
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 16 }}>
          <div style={{ position: 'relative', flex: '1 1 280px', maxWidth: 420 }}>
            <Icon name="search" size={17} style={{ position: 'absolute', left: 13, top: 11, color: 'var(--text-muted)' }} />
            <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar por arquivo, código ou contrato-base…"
              style={{ width: '100%', padding: '10px 12px 10px 40px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border)', background: 'var(--surface-2)', color: 'var(--text-strong)', fontSize: 13.5, outline: 'none' }} />
          </div>
          <select value={fStatus} onChange={e => setFStatus(e.target.value)}
            style={{ padding: '10px 14px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border)', background: 'var(--surface-2)', color: 'var(--text-strong)', fontSize: 13.5, fontWeight: 600, outline: 'none', cursor: 'pointer' }}>
            <option value="all">Todos os status</option>
            <option value="vinculado">Vinculados</option>
            <option value="naovinculado">Não vinculados</option>
          </select>
        </div>
      )}

      {lista === null ? (
        <Card pad={40} style={{ textAlign: 'center', color: 'var(--text-muted)' }}>
          <span style={{ width: 34, height: 34, border: '4px solid var(--surface-inset)', borderTopColor: 'var(--booker-orange)', borderRadius: 99, display: 'inline-block', animation: 'spin .8s linear infinite' }} />
          <div style={{ marginTop: 14, fontSize: 14 }}>Carregando aditivos…</div>
        </Card>
      ) : aditivos.length === 0 ? (
        <Card pad={40} style={{ textAlign: 'center', color: 'var(--text-muted)' }}>
          <Icon name="link" size={32} style={{ color: 'var(--text-faint)' }} />
          <div style={{ marginTop: 12, fontSize: 14 }}>Nenhum aditivo ainda. Ao importar um PDF de aditivo na aba <b>Contratos</b>, ele aparece aqui para você vincular ao contrato-base.</div>
        </Card>
      ) : (
        <Card pad={0} style={{ overflow: 'hidden' }}>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13.5 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid var(--border)', textAlign: 'left' }}>
                  <Th>Aditivo</Th><Th>Contrato-base</Th><Th>Status</Th><Th right>Ações</Th>
                </tr>
              </thead>
              <tbody>
                {filtrada.map((a, i) => {
                  const sugerida = !a.contratoBaseId && baseSugerida(a);
                  const semBase = !a.contratoBaseId && !sugerida;
                  return (
                    <tr key={a.id} style={{ borderTop: i ? '1px solid var(--border)' : 'none' }}>
                      <td style={{ padding: '12px 16px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <span style={{ fontSize: 10, fontWeight: 800, color: 'var(--info)', background: 'var(--info-bg)', padding: '2px 7px', borderRadius: 5 }}>{a.numeroAditivo ? `Nº ${a.numeroAditivo}` : 'ADITIVO'}</span>
                          <span className="mono" style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)' }}>{a.codigo}</span>
                        </div>
                        <div style={{ fontSize: 12, color: 'var(--text-strong)', marginTop: 3, maxWidth: 340, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{a.arquivo}</div>
                      </td>
                      <td style={{ padding: '12px 16px' }}>
                        {a.base ? (
                          <button onClick={() => onNavigate('detalhe', a.base.id)} style={{ background: 'none', border: 'none', padding: 0, textAlign: 'left', cursor: 'pointer' }}>
                            <div className="mono" style={{ fontSize: 12.5, fontWeight: 700, color: 'var(--info)' }}>{a.base.codigo}</div>
                            <div style={{ fontSize: 11.5, color: 'var(--text-muted)', maxWidth: 200, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{a.base.razao}</div>
                          </button>
                        ) : (
                          <div>
                            <select value={sel[a.id] !== undefined ? sel[a.id] : (sugerida ? sugerida.dbId : '')} onChange={e => setSel(s => ({ ...s, [a.id]: e.target.value }))} style={campoSel}>
                              <option value="">— escolher base —</option>
                              {bases.map(x => <option key={x.dbId} value={x.dbId}>{x.codigo} · {x.cliente.razao}</option>)}
                            </select>
                            {semBase
                              ? <div style={{ fontSize: 11, color: 'var(--booker-orange)', fontWeight: 600, marginTop: 4 }}>⚠ sem correspondência por CNPJ — selecione manualmente</div>
                              : <div style={{ fontSize: 11, color: 'var(--ok)', marginTop: 4 }}>✓ sugerido pelo CNPJ</div>}
                          </div>
                        )}
                      </td>
                      <td style={{ padding: '12px 16px' }}>
                        {a.contratoBaseId
                          ? <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--ok)', background: 'var(--info-bg)', padding: '3px 9px', borderRadius: 99 }}>● Vinculado</span>
                          : <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--booker-orange)', background: 'var(--warn-bg)', padding: '3px 9px', borderRadius: 99 }}>● Não vinculado</span>}
                        {a.aplicadoEm && <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>✓ aplicado</div>}
                      </td>
                      <td style={{ padding: '12px 16px' }}>
                        <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
                          <Button size="sm" variant="ghost" icon="external" onClick={() => window.Api.abrirAditivo(a.arquivo)}>Abrir</Button>
                          {podeEditar && (a.contratoBaseId ? (
                            <>
                              <Button size="sm" variant="accent" icon="refresh" onClick={() => aplicar(a)}>{busy === a.id ? '…' : 'Aplicar'}</Button>
                              <Button size="sm" variant="default" onClick={() => desvincular(a)}>{busy === a.id ? '…' : 'Desvincular'}</Button>
                            </>
                          ) : (
                            <Button size="sm" variant="accent" icon="link" onClick={() => vincular(a)}>{busy === a.id ? '…' : 'Vincular'}</Button>
                          ))}
                          {podeEditar && <button onClick={() => excluir(a)} disabled={busy === a.id} title="Excluir aditivo" style={{ width: 32, height: 32, borderRadius: 7, border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--danger)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: busy === a.id ? 'wait' : 'pointer', flexShrink: 0 }}>
                            <Icon name="trash" size={15} />
                          </button>}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {(busca || fStatus !== 'all') && <div style={{ padding: '10px 16px', fontSize: 12, color: 'var(--text-muted)', borderTop: '1px solid var(--border)' }}>{filtrada.length} de {aditivos.length}</div>}
        </Card>
      )}

      {lista !== null && aditivos.length > 0 && filtrada.length === 0 && (
        <Card pad={28} style={{ textAlign: 'center', color: 'var(--text-muted)', marginTop: 12 }}>Nenhum aditivo corresponde ao filtro.</Card>
      )}
    </div>
  );
}

function Th({ children, right }) {
  return <th style={{ padding: '12px 16px', fontSize: 11.5, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.04em', textAlign: right ? 'right' : 'left' }}>{children}</th>;
}
function Kpi({ label, value, tone }) {
  return (
    <Card pad={16}>
      <div style={{ fontSize: 28, fontWeight: 800, color: tone, letterSpacing: '-.02em', lineHeight: 1 }} className="tnum">{value}</div>
      <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--text-muted)', marginTop: 6 }}>{label}</div>
    </Card>
  );
}

Object.assign(window, { Aditivos });
